<template>
  <el-row>
    <el-col :xs="24">
      <el-card
        v-loading="isLoading">
        <div slot="header" class="clearfix">
          <span class="cadastro-title">Centro de Custo -  {{ isEditing ? 'Editar' : 'Visualizar'}}</span>
          <a class="pull-right" style="cursor: pointer" @click="toList()"><i class="icon-close"></i></a>
        </div>
        <el-form label-position="left" label-width="100px" :model="selected" ref="selected" v-if="selected">

          <el-form-item label="Nome" :error="errors.nome">
            <el-input v-model="selected.nome" :readonly="!isEditing"/>
          </el-form-item>

          <el-form-item label="Usuário"  :error="errors.user_id" :md="8">
            <el-select v-model="selected.user_id" filterable placeholder="Selecione" :disabled="! isEditing">
              <el-option
                v-for="item in userList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Superior"  :error="errors.parent_id" :md="8">
            <el-select v-model="selected.parent_id" clearable filterable placeholder="Selecione" :disabled="! isEditing">
              <el-option
                v-for="item in centroCustoList"
                :key="item.id"
                :label="item.nome"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Árvore"  :error="errors.arvore_id" :md="8">
            <el-select v-model="selected.arvore_id" filterable placeholder="Selecione" :disabled="! isEditing">
              <el-option
                v-for="item in arvoreList"
                :key="item.id"
                :label="item.nome"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item align="right">
            <el-button type="warning" @click="toList()">Lista</el-button>
            <el-button type="danger" v-show="! isEditing" @click="isEditing = true">Editar</el-button>
            <el-button type="primary" @click="onSubmit" v-show="isEditing">Salvar</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
  </el-row>
</template>

<style>
  .centrocusto-show-card-seeder .el-card__header {
    color: #ffffff;
    background-color: #2E2E2E;
  }
</style>

<script>

  import {error_form_transform} from "../../domain/utils";
  import {mapState, mapActions} from 'vuex'

  export default {
    name: "centrocusto-show",
    data() {
      return {
        isLoading: false,
        isEditing: false,
        errors: {
          nome: null,
          user_id: null,
          parent_id: null,
          arvore_id: null
        }
      }
    },
    computed: {
      ...mapState('CentroCusto', ['selected']),
      ...mapState(['userList', 'centroCustoList', 'arvoreList']),
      centroCustoId() {
        return this.$route.params.centrocusto
      }
    },
    methods: {
      ...mapActions('CentroCusto', ['setSelected' , 'update']),
      async onSubmit() {
        try {
          this.isLoading = true
          await this.update(this.selected)
          this.$notify.success("Registro Atualizado com sucesso!")
        }
        catch (error) {
          if (_.isObjectLike(error.response)) {
            this.errors = error_form_transform(error.response.data.errors)
          }
          console.log(error)
        }
        finally {
          this.isLoading = false
        }
      },
      toList() {
        this.$router.push({name: 'centrocusto.index'})
      }
    },
    async mounted() {
      try {
        this.isLoading = true
        await this.setSelected({id: this.centroCustoId})
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/features/Centro/Show.vue